import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import Slideout from 'slideout';

@Component({
	selector: 'app-guest-sidebar',
	templateUrl: './guest-sidebar.component.html',
	styleUrls: ['./guest-sidebar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class GuestSidebarComponent implements OnInit, OnDestroy {
	public navSlideout;

	private toggleButtonHandler: () => void;

	get loginLink(): string {
		return '/login';
	}

	get registerLink(): string {
		return '/signup';
	}

	ngOnInit(): void {
		this.createSlideout();
	}

	ngOnDestroy() {
		document.querySelector('.toggle-button')?.removeEventListener('click', this.toggleButtonHandler);
		this.navSlideout?.destroy();
	}

	toggleButtonClass() {
		const toggleButton = document.querySelector('.toggle-button');
		if (toggleButton.getAttribute('class').indexOf('nav-open') === -1) {
			toggleButton.classList.add('nav-open');
		} else {
			toggleButton.classList.remove('nav-open');
		}
		this.navSlideout.toggle();
	}

	onLinkClick() {
		this.toggleButtonClass();
		this.navSlideout.close();
	}

	createSlideout() {
		this.navSlideout = new Slideout({
			panel: document.getElementById('slider-panel-features'),
			menu: document.getElementById('slider-menu'),
			// eslint-disable-next-line no-restricted-globals
			padding: screen.width,
		});

		this.toggleButtonHandler = () => this.toggleButtonClass();
		document.querySelector('.toggle-button').addEventListener('click', this.toggleButtonHandler);
	}
}
